// Login.js — handle entry, then OAuth via AuthContext.
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { safeReturnUrl } from '../../lib/url';

const Login = () => {
  const [handle, setHandle] = useState('');
  const { login, loading, error, isAuthenticated } = useAuth();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  // Never redirect to a query-provided foreign origin (open redirect).
  const returnUrl = safeReturnUrl(
    queryParams.get('returnUrl'),
    window.location.origin,
    '/'
  );

  useEffect(() => {
    if (isAuthenticated) {
      setTimeout(() => {
        window.location.replace(returnUrl);
      }, 100);
    }
  }, [isAuthenticated, returnUrl]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await login(handle || null, returnUrl);
    } catch (err) {
      console.error('Login error:', err);
    }
  };

  if (isAuthenticated) {
    return (
      <div className="login-page">
        <div className="login-content">
          <p>Already logged in. Redirecting...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-content">
        <h1>timer</h1>
        <p>
          Sort your Bluesky blocks into time-boxed moderation lists
          (T-1 / T-7 / T-30) and get a DM when it is time to remove them.
        </p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="handle-input">Bluesky handle</label>
          <input
            id="handle-input"
            type="text"
            value={handle}
            onChange={(e) => setHandle(e.target.value)}
            placeholder="username.bsky.social"
            disabled={loading}
            autoComplete="username"
          />
          {loading && <p>Starting login...</p>}
          {error && <p className="error-text">Login failed: {error}</p>}
          <button type="submit" disabled={loading || isAuthenticated}>
            {loading ? 'Starting login...' : 'Login with Bluesky'}
          </button>
        </form>
        <p className="muted">
          We use official Bluesky/ATProto OAuth. timer only ever writes via
          your own session and never posts.
        </p>
      </div>
    </div>
  );
};

export default Login;
